import React, { Component, useEffect, useState } from "react";
import { useAlert } from "../context/AlertContext";
import { useLoading } from "context/LoadingContext";
import { fetchVendorLedgerDetails } from "../Service/ApiService";
import { IconButton, Tooltip } from "@mui/material";
import { Download, RemoveRedEye } from "@mui/icons-material";
import { useLocation } from "react-router-dom";

const VendorLedgerDetailsController = () => {
  // Fetch vendor code from localstorage
  const vendordetails = JSON.parse(localStorage.getItem("vendor"));
  const vendorCode = vendordetails ? vendordetails.vendorCode : null;
  const location = useLocation();

  // Props
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const { month, year, opening } = location.state || {};
  const [expand, setExpand] = useState(false);

  // Contexts
  const { setLoading } = useLoading();

  // Data
  const columnsFields = [
    { Header: "Posting Date", accessor: "postingDate", width: "5%", align: "left" },
    { Header: "Doc. Date", accessor: "docDate", align: "left" },
    { Header: "Type", accessor: "type", align: "left" },
    { Header: "Dr. Amount", accessor: "drAmount", align: "left" },
    { Header: "Cr. Amount", accessor: "crAmount", align: "left" },
    { Header: "Balance", accessor: "balance", align: "left" },
    // {
    //   Header: "FI Doc",
    //   accessor: "fiDoc",
    //   align: "left",
    //   // eslint-disable-next-line react/prop-types
    //   Cell: ({ row }) => {
    //     // eslint-disable-next-line react/prop-types
    //     const label = row.original.fiDoc;
    //     // eslint-disable-next-line react/prop-types
    //     const url = row.original.fiDocURL ?? window.location.href;

    //     return label ? (
    //       <a
    //         href={url}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         style={{ color: "#1a73e8", textDecoration: "underline" }}
    //       >
    //         {label}
    //       </a>
    //     ) : (
    //       "-"
    //     );
    //   },
    // },
    // {
    //   Header: "Sales Crno.",
    //   accessor: "SalesCrno",
    //   align: "left",
    //   // eslint-disable-next-line react/prop-types
    //   Cell: ({ row }) => {
    //     // eslint-disable-next-line react/prop-types
    //     const label = row.original.SalesCrno;
    //     // eslint-disable-next-line react/prop-types
    //     const url = row.original.SalesCrnoURL ?? window.location.href;

    //     return label ? (
    //       <a
    //         href={url}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         style={{ color: "#1a73e8", textDecoration: "underline" }}
    //       >
    //         {label}
    //       </a>
    //     ) : (
    //       "-"
    //     );
    //   },
    // },
    // {
    //   Header: "Scheme Crno.",
    //   accessor: "schemecrno",
    //   align: "left",
    //   // eslint-disable-next-line react/prop-types
    //   Cell: ({ row }) => {
    //     // eslint-disable-next-line react/prop-types
    //     const label = row.original.schemecrno;
    //     // eslint-disable-next-line react/prop-types
    //     const url = row.original.schemecrnoURL ?? window.location.href;

    //     return label ? (
    //       <a
    //         href={url}
    //         target="_blank"
    //         rel="noopener noreferrer"
    //         style={{ color: "#1a73e8", textDecoration: "underline" }}
    //       >
    //         {label}
    //       </a>
    //     ) : (
    //       "-"
    //     );
    //   },
    // },
    { Header: "Particular", accessor: "particular", align: "left" },
  ];

  const expandedColumnFields = [];

  // Use Effects
  // Fetch vendor PO
  useEffect(() => {
    setColumns(columnsFields);
    getVendorLedger();
  }, []);

  const getVendorLedger = async () => {
    try {
      setLoading(true);

      const response = await fetchVendorLedgerDetails(vendorCode, month, year, opening);

      if (response && response.success === "true") {
        setRows(response.data.transactions);
      } else {
        // Handle failure case: clear data
        setRows([]);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error during fetching ledger data:", error);

      // Optional: fallback state
      setRows([]);
    }
  };

  // Expand table
  const toggleExpand = () => {
    const newExpand = !expand;
    setExpand(newExpand);

    if (newExpand) {
      setColumns([...columnsFields, ...expandedColumnFields]);
    } else {
      setColumns(columnsFields);
    }
  };

  return {
    columns,
    rows,
    expand,
    toggleExpand,
  };
};

export default VendorLedgerDetailsController;
